import { useEffect, useState } from "react";

/** Re-render-driving clock. Kept out of usePoll so staleness UI updates even
 *  when no new data arrives. */
export function useNow(intervalMs: number = 500): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
